import React, {Component} from 'react';
import Form from "../../../components/form/Form";

export default class JobReferralModal extends Component {

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
        this.state = {
            ...this.state,
            isDisabled: props.isDisabled,
            referral: {
                project_position_id: props.job.id
            }
        };
    }

    formFields()
    {
        return [
            {
                fields: {
                    subtitle: (
                        <div className="referral-form-info">
                            <h4>
                                {<span dangerouslySetInnerHTML={{__html: TB.trans('talent.job_board.referral_form_title', {
                                        job_title: `<span class="text-primary">${this.props.job.title}</span>`
                                    })
                                }}/>}
                            </h4>
                            <p>
                                {TB.trans('talent.job_board.referral_form_subtitle')}
                            </p>
                        </div>
                    ),
                    project_position_id: {
                        type: 'hidden'
                    },
                }
            },
            {
                style: {flexDirection: 'row'},
                fields: {
                    first_name: {
                        required: true,
                        columns: 6
                    },
                    last_name: {
                        required: true,
                        columns: 6
                    },
                }
            },
            {
                fields: {
                    email: {
                        type: 'email',
                        required: true,
                    },
                }
            }

        ];
    }

    async resetForm() {
        await this.formRef.current?.forceReset();
        return this.setState({didSend: false, referral: {}});
    }
    /**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model)
    {
        model.user_type = laravel.user_types.talent;

        return model;
    }

    onChange(model)
    {
        this.setState({referral: model})
    }

    async onBeforeError(error)
    {
        await this.props.onToggleDisabled(false);
        return TB.showServerErrorToast();
    }

    render() {
        return (
            <Form
                ref={this.formRef}
                showRequired
                submitButton={"Send"}
                post="/api/platform-referrals/create"
                model={this.state.referral}
                mapping={this.mapping.bind(this)}
                onChange={this.onChange.bind(this)}
                onError={e => {
                    console.warn('ERROR: ', e);

                    TB.showServerErrorToast();
                }}
                onSuccess={this.props.onSuccess}
                // onBeforeError={this.onBeforeError.bind(this)}
                fields={this.formFields()}
                isDisabled={this.state.isDisabled || this.props.isDisabled}/>
        );
    }
};
